import React, { useState } from 'react';
import { Box, Container, Typography, TextField, Button } from '@mui/material';
import MarketingHeader from './MarketingHeader';
import MarketingFooter from './MarketingFooter';

const NewsletterBar = () => {
  const [email, setEmail] = useState('');

  return (
    <Box sx={{ backgroundColor: '#0d9488', py: 4 }}>
      <Container maxWidth="md" sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', gap: 2 }}>
        <Typography variant="body1" sx={{ color: 'white', flex: 1, fontWeight: 500 }}>
          Get insider access to iAngels' top stories by joining our mailing list
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, width: { xs: '100%', sm: 'auto' } }}>
          <TextField
            size="small"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ backgroundColor: 'white', borderRadius: 1, minWidth: 220, '& .MuiOutlinedInput-notchedOutline': { border: 'none' } }}
          />
          <Button variant="contained" sx={{ backgroundColor: '#0a3d3d', textTransform: 'none', '&:hover': { backgroundColor: '#072e2e' } }}>
            Subscribe
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

const MarketingLayout = ({ children }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <MarketingHeader />
    <Box component="main" sx={{ flex: 1 }}>
      {children}
    </Box>
    <NewsletterBar />
    <MarketingFooter />
  </Box>
);

export default MarketingLayout;
